import React from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import {APP_URL} from "../utils/constants";

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href={APP_URL}>
        QCerris
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default Copyright;
